import { Navigate, Outlet } from "react-router";

import { useUser } from "@/client/services/user";

export const AdminGuard = () => {
  // See AdminObservabilityGuard: wait for the /me query (`loading`) before
  // judging admin status, otherwise a cold deep-link load races hydration and
  // bounces real admins to `/` while the store user is momentarily null.
  const { user, loading } = useUser({ force: true });

  if (loading) return null;

  if (!user) {
    return <Navigate replace to="/auth/login" />;
  }

  if (!user.isAdmin) {
    return <Navigate replace to="/" />;
  }

  return <Outlet />;
};
